var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48566 0 0 4.48566 0 10C0 15.5143 4.48566 20 10 20C15.5143 20 20 15.5136 20 10C20 4.48645 15.5143 0 10 0ZM10 18.4508C5.34082 18.4508 1.54918 14.66 1.54918 10C1.54918 5.34004 5.34082 1.54918 10 1.54918C14.66 1.54918 18.4508 5.34004 18.4508 10C18.4508 14.66 14.6592 18.4508 10 18.4508Z",
    fill: "#3EC09C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5879 6.52208C14.2727 6.23548 13.7824 6.25794 13.4942 6.57474L8.76918 11.7777L6.48645 9.45704C6.18512 9.15185 5.69559 9.1472 5.39117 9.44774C5.08598 9.74751 5.08133 10.2378 5.38188 10.543L8.23934 13.4477C8.38575 13.5965 8.58403 13.6793 8.79161 13.6793C8.79626 13.6793 8.80168 13.6793 8.80633 13.6801C9.02012 13.6755 9.22153 13.5841 9.36481 13.4261L14.6406 7.61661C14.928 7.299 14.9047 6.80946 14.5879 6.52208Z",
    fill: "#3EC09C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a06456031892f34748c4174e7d5b2685.svg";
export { ForwardRef as ReactComponent };